import React, { useEffect,useState } from "react";
import { Modal } from 'react-bootstrap';
import MediaSelectBox from "./MediaSelectBox"
import './sidebarfilter.scss';
import {getData} from "./api/api";
export default function MediaPlaylistFilter(props) {
    const [mediaExtraFieldData, setMediaExtraFieldData] = useState([]);
    const [language, setLanguage] = useState([]);
    const [product, setProduct] = useState([]);
    const aspectRatio = [
        {"label":'All',"value":''},
        {"label":'1:1',"value":'1:1'},
        {"label":'3:4',"value":'3:4'},
        {"label":'4:3',"value":'4:3'},
        {"label":'2:3',"value":'2:3'},
        {"label":'3:2',"value":'3:2'},
        {"label":'16:9',"value":'16:9'},
        {"label":'9:16',"value":'9:16'},
        {"label":'Outdoor Fascia',"value":'outdoor_fascia'},
    ]
    const [aspectRatioData, setAspectRatioData] = useState(localStorage.getItem('aspectRatioData'));
    const [filterLanguage, setFilterLanguage] = useState(localStorage.getItem('filterLanguage'));
    const [filterProduct, setFilterProduct] = useState(localStorage.getItem('filterProduct'));

    useEffect(() => {
        let language = mediaExtraFieldData.languages;
        if(mediaExtraFieldData.languages !== undefined){
            let lanData = mediaExtraFieldData.languages.map((lan) => {
                return {'label':lan.name,value:lan.id}
            })
            lanData.unshift({'label':'All',value:''})
            setLanguage(lanData)
        }
        if(mediaExtraFieldData.product_categories !== undefined){
            let product = mediaExtraFieldData.product_categories.map((product) => {
                return {'label':product.name,value:product.id}
            })
            product.unshift({'label':'All',value:''})
            setProduct(product)
        }
    }, [mediaExtraFieldData])

    useEffect(() => {
        getData(`materials/language_categories`,setMediaExtraFieldData)
    }, [])
    const closePreview = () => {
        props.closePreview(false);
        localStorage.setItem('aspectRatioData',aspectRatioData);
        localStorage.setItem('filterLanguage',filterLanguage);
        localStorage.setItem('filterProduct',filterProduct);
        props.filterData(aspectRatioData,filterLanguage,filterProduct,false);
    }

    return (
        <>
            <div>
                <div className="App p-4 sidebarFilter">
                    <Modal className="sidebar-filter" centered size="lg" show={props.show}>
                        <Modal.Header closeButton onClick={closePreview}>
                            <Modal.Title>Filter</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="sidebar-filter-content">
                            <div className="media-div-box">
                                <div className="media-select-div">
                                    <span>Aspect Ratio</span>
                                    <MediaSelectBox id={'filter-aspectRatio'} menuItem={aspectRatio} selected={localStorage.getItem('aspectRatioData')} setDropDownValue={setAspectRatioData}/>
                                </div>
                                <div className="media-select-div">
                                    <span>Language</span>
                                    <MediaSelectBox id={'filter-language'} menuItem={language} selected={localStorage.getItem('filterLanguage')} setDropDownValue={setFilterLanguage}/>
                                </div>
                            </div>
                            <div className="media-div-box">
                                <div className="media-select-div">
                                    <span>Product</span>
                                    <MediaSelectBox id={'filter-product'} menuItem={product} selected={localStorage.getItem('filterProduct')} setDropDownValue={setFilterProduct}/>
                                </div>
                                <div className="media-select-div">
                                    {/*<span>Tag</span>*/}
                                    {/*<MediaSelectBox menuItem={product}/>*/}
                                </div>
                            </div>
                            <div className="mt-4 d-flex gap-3 justify-content-center">
                                <button className="btn btn-save-button filter-apply-btn" onClick={closePreview}>Apply
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>
    )
}